import { useState, useRef, useEffect, useCallback } from "react";
import isObjectLike from "../vendor/lodash-es/isObjectLike.js";
import isEqual from "../vendor/lodash-es/isEqual.js";
const createEvent = ({
  value,
  name,
  original
}) => ({
  ...original,
  target: { value, name, ...original == null ? void 0 : original.target }
}), inputIsControlled = (v) => typeof v < "u", useInternalControlled = ({
  onChange,
  value,
  delay = 600,
  onPreChange,
  disable,
  forced
}) => {
  const [internalValue, setInternalValue] = useState(
    forced ? value ?? "" : value
  ), dataRef = useRef({ onChange, onPreChange, forced });
  dataRef.current = {
    onChange,
    onPreChange,
    forced
  };
  const setValue = (value2) => {
    setInternalValue((onPreChange == null ? void 0 : onPreChange(value2)) ?? value2 ?? void 0);
  };
  useEffect(() => {
    disable || (inputIsControlled(value) || dataRef.current.forced) && value !== internalValue && setValue(value);
  }, [value]), useEffect(() => {
    if (value == null || disable)
      return;
    const tmt = setTimeout(() => {
      (isObjectLike(value) ? !isEqual(value, internalValue) : value !== internalValue) && (inputIsControlled(value) || dataRef.current.forced) && setValue(value);
    }, delay);
    return () => clearTimeout(tmt);
  }, [internalValue]);
  const handleChange = useCallback(
    (e) => {
      var _a, _b, _c, _d;
      const val = e.target.value, name = e.target.name, changedValue = ((_b = (_a = dataRef.current).onPreChange) == null ? void 0 : _b.call(_a, val)) ?? val;
      (_d = (_c = dataRef.current).onChange) == null || _d.call(_c, createEvent({ name, value: changedValue })), (inputIsControlled(value) || dataRef.current.forced) && setInternalValue(changedValue);
    },
    [value]
  );
  return {
    handleChange: disable ? onChange : handleChange,
    internalValue: disable ? value : internalValue
  };
};
export {
  createEvent,
  useInternalControlled
};
//# sourceMappingURL=useInternalControlled.js.map
